<p-tabView [(activeIndex)]="configuration.activeIndex" (onChange)="configuration.action($event)">

    <p-tabPanel [header]="title" *ngFor="let title of configuration.titles"></p-tabPanel>

</p-tabView>
